import React, { ReactNode } from 'react';
import { CheckCircle } from 'lucide-react';

interface CheckListItemProps {
  children: ReactNode;
  iconClassName?: string;
  textClassName?: string;
}

const CheckListItem: React.FC<CheckListItemProps> = ({ 
  children, 
  iconClassName = "text-primary",
  textClassName = ""
}) => (
  <li className="flex items-start">
    <CheckCircle className={`w-5 h-5 mt-1 mr-3 flex-shrink-0 ${iconClassName}`} />
    <span className={textClassName}>{children}</span>
  </li>
);

export default CheckListItem; 